import React from 'react';
import { motion } from 'framer-motion';

const NODES = [
  { label: 'Classification Evidence Record',   id: 'CER-2026-001',         publicId: 'Classification · 2026-001',  grade: 'AUDIT-GRADE', gradeOk: true, facts: ['HIGH-RISK · Deployer', 'EU AI Act Annex III'],   color: '#6366F1' },
  { label: 'Control State at Decision Time',    id: 'CSS-2026-047832',     publicId: 'Control State · 2026-047832', grade: 'AUDIT-GRADE', gradeOk: true, facts: ['94% coverage', 'All controls active'],            color: '#6366F1' },
  { label: 'Decision Evidence Record',          id: 'DER-2026-047832',     publicId: 'Decision · 2026-047832',     grade: 'AUDIT-GRADE', gradeOk: true, facts: ['Confidence 0.94', '9/9 controls'],                color: '#6366F1' },
  { label: 'Oversight Evidence Record',         id: 'OER-2026-047832',     publicId: 'Oversight · 2026-047832',    grade: 'AUDIT-GRADE', gradeOk: true, facts: ['4m 12s review', 'CA-4471 certified'],             color: '#6366F1' },
  { label: 'Evidence Package',                  id: 'PKG-2026-Q1-003',     publicId: 'Package · 2026-Q1-003',      grade: 'AUDIT-GRADE', gradeOk: true, facts: ['Complete · Signed', 'Export ready'],              color: '#10B981' },
];

function Node({ n, isLast, publicMode }) {
  const displayId = publicMode ? n.publicId : n.id;
  return (
    <div style={{
      flex: '1 1 180px',
      minWidth: 180,
      border: '1px solid #1E2A45',
      borderLeft: isLast ? '3px solid #10B981' : '1px solid #1E2A45',
      background: '#0F1629',
      borderRadius: 12,
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
    }} data-testid={`proof-node-${n.id}`}>
      <div style={{ fontSize: 8, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.14em', fontFamily: 'JetBrains Mono, monospace' }}>
        {n.label}
      </div>
      <div style={{ fontSize: 11, color: '#F8FAFC', fontFamily: 'JetBrains Mono, monospace', fontWeight: 700 }}>
        {displayId}
      </div>
      <div style={{ fontSize: 10, color: n.gradeOk ? '#10B981' : '#F59E0B', fontFamily: 'JetBrains Mono, monospace', fontWeight: 600 }}>
        ◆ {n.grade}
      </div>
      <div style={{ borderTop: '1px solid #1E2A45', paddingTop: 6, marginTop: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {n.facts.map((f) => (
          <span key={f} style={{ fontSize: 9, color: '#94A3B8', lineHeight: 1.4 }}>{f}</span>
        ))}
      </div>
    </div>
  );
}

export default function ProofChainVisual({ publicMode = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      data-testid="proof-chain-visual"
      style={{
        display: 'flex',
        alignItems: 'stretch',
        gap: 6,
        flexWrap: 'wrap',
      }}
    >
      {NODES.map((n, i) => (
        <React.Fragment key={n.id}>
          <Node n={n} isLast={i === NODES.length - 1} publicMode={publicMode} />
          {i < NODES.length - 1 && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              color: '#334155',
              fontSize: 18,
              flexShrink: 0,
              padding: '0 2px',
            }} aria-hidden>→</div>
          )}
        </React.Fragment>
      ))}
    </motion.div>
  );
}
